/**
 * Create the store with dynamic reducers
 */

import { configureStore, StoreEnhancer } from '@reduxjs/toolkit';
import { createInjectorsEnhancer } from 'redux-injectors';
import createSagaMiddleware from 'redux-saga';

import { createReducer } from './reducers';

export function configureAppStore() {
  const reduxSagaMonitorOptions = {};
  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);
  const { run: runSaga } = sagaMiddleware;

  const store = configureStore({
    reducer: createReducer(),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
    devTools: import.meta.env.DEV,
    enhancers: getDefaultEnhancers =>
      getDefaultEnhancers().concat(
        // redux-injectors 2.x is typed against redux 4's StoreEnhancer; RTK 2 ships
        // redux 5. Runtime is identical — only the cross-version types differ.
        createInjectorsEnhancer({ createReducer, runSaga }) as StoreEnhancer,
      ),
  });

  return store;
}
